componentRegistryInstance.register('date', 'edit', 'hrd.components.form.DateComponent');
componentRegistryInstance.register('date', 'read', 'hrd.components.form.DateComponent');

hrd.components.form.DateComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.DateComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditField: function(field, id, klass) {
		this._super(field, id, klass);
		this.dateOptions = this.utils().date().options(field.data('format'));
		if (field.data('showOn')) {
			this.dateOptions.showOn = field.data('showOn') || 'button';
		}
		// TODO: must be moved during initialisation/reset phase, because re-entering on a open dialog we don't need to enhance again
		if (field.data('default') !== undefined) {
			var defaultDate = this.utils().date().patternToDate(field.data('default'), field.data('format'));
			field.val(defaultDate);
		}
		field.datepicker(this.dateOptions).addClass('center-align');
		field.parent().css('white-space', 'nowrap'); // used to avoid calendar icon on new line

		$.timeout(300)
			.then(() => this._postEnhance(field));
	},
	_postEnhance: function(field) {
		if (this.dateOptions.showOn === 'off') return;

		if (!field.usingChromaFlow()) return;

		let customPosition = undefined;
		if (field.data('custom-position') == true) {
			let fnCustomPosition = $.functionCase(field.data('name') + '-custom-position');
			if (this.settings.reference && typeof this.settings.reference[fnCustomPosition] == 'function') {
				customPosition = this.settings.reference[fnCustomPosition].call(this.settings.reference, field, this.getFormInstance());
			} else {
				console.log(`function "${fnCustomPosition}" not available in proper object reference "${this.settings.reference._FULL_}". Add it in order to configure "custom position" for date picker properly`);
			}
		}

		const $trigger = this.getTrigger(field);

		$trigger.attr('data-variants', 'datepicker-addon');

		this.wrapForDatepickerAddon(field);

		const $datepicker = this.toolbox.get('datepicker.dpDiv', field.data());

		$datepicker
			.addClass('popover closed')
			.attr('data-state', 'closed');

		let position = $.extend({
			my: 'center top',
			at: 'center bottom',
			of: field,
		}, customPosition);

		switch (this.dateOptions.showOn) {
			case 'button':
				this.datePickerButtonHandler($trigger, $datepicker, position);
				break;
			case 'focus':
				this.datePickerFocusHandler(field, $datepicker, position);
				break;
			case 'both':
				this.datePickerButtonHandler($trigger, $datepicker, position);
				this.datePickerFocusHandler(field, $datepicker, position);
				break;
		}

		this.datePickerCloseHandler();

	},
	enhanceReadField: function(field, id, klass) {
		var alreadyEnhancedField = !!field.data('already-enhanced');
		if (!alreadyEnhancedField && field.data('show-datepicker')) {
			var options = this.utils().date().options(field.data('format'));
			klass += ' ignore-for-fhs';

			if (field.data('calendar-opts')) {
				let calendarOpts = $.evaluate(field.data('calendar-opts'), this.settings.reference);
				if ($.isPlainObject(calendarOpts)) {
					options = $.extend(options, calendarOpts);
				}
			}
			/* used for rendering day cell based on custom data */
			if (field.data('beforeShowDay') == true) {
				let fnBSD = $.functionCase(field.data('name') + '-before-show-day');
				if (this.settings.reference && typeof this.settings.reference[fnBSD] == 'function') {
					let fn = this.settings.reference[fnBSD].call(this.settings.reference, field, this.getFormInstance());
					options.beforeShowDay = fn;
				} else {
					console.log(`function "${fnBSD}" not available in proper object reference "${this.settings.reference._FULL_}". Add it in order to configure date picker properly`);
				}
			}
			if (field.data('onSelect') == true) {
				let fnSelect = $.functionCase(field.data('name') + '-on-select');
				if (this.settings.reference && typeof this.settings.reference[fnSelect] == 'function') {
					let fn = this.settings.reference[fnSelect].call(this.settings.reference, field, this.getFormInstance());
					options.onSelect = fn;
				} else {
					console.log(`function "${fnSelect}" not available in proper object reference "${this.settings.reference._FULL_}". Add it in order to configure date picker properly`);
				}
			}
			if (field.data('onChangeMonthYear') == true) {
				let fnChange = $.functionCase(field.data('name') + '-on-change-month-year');
				if (this.settings.reference && typeof this.settings.reference[fnChange] == 'function') {
					let fn = this.settings.reference[fnChange].call(this.settings.reference, field, this.getFormInstance());
					options.onChangeMonthYear = fn;
				} else {
					console.log(`function "${fnChange}" not available in proper object reference "${this.settings.reference._FULL_}". Add it in order to configure date picker properly`);
				}
			}
			field.datepicker(options).addClass('center-align');
			field.data('already-enhanced', true);
		}
		this._super(field, id, klass);
	},
	getEditableField: function(field, name, object, options) {
		var sDate = field.val();
		if ($.formUtils.parseDate(sDate, 'dd/mm') !== false && !(field.data('skip-year-suffix') == true)) {
			// it means that the date is parsable with dd/mm and so the year part is missing
			var defaultYear = field.data('default-year') || '1970';
			sDate += '/' + defaultYear;
		}
		this.setValueByPath(object, name, sDate);
	},
	getReadOnlyField: function(field, name, object, options) {
		if (field.data('show-datepicker')) {
			// need to read selected day from datepicker instance
			let datepickerInstance = field.data('datepicker');
			if (datepickerInstance != undefined) {
				let dd = this.toolbox.leftPad(datepickerInstance.selectedDay, 2, '0');
				let mm = this.toolbox.leftPad(1 + datepickerInstance.selectedMonth, 2, '0');
				let yyyy = datepickerInstance.selectedYear;
				let sDate = `${dd}/${mm}/${yyyy}`;
				this.setValueByPath(object, name, sDate);
			}
		} else {
			this._super(field, name, object, options);
		}
	},
	setEditableField: function(field, value, object, options) {
		this._super(field, value, object, options);
	},
	setReadOnlyField: function(field, value, object, options) {
		if (field.data('show-datepicker')) {
			if (value) {
				$(field).datepicker('setDate', value);
			}
		} else {
			this._super(field, value, object, options);
		}
	},
	initalizeComponent: function(field, initialValue) {
		var date;
		var sFormat = field.data('format');
		if (initialValue === 'customFn') {
			var customFn = $.functionCase(field.data('name') + '-init-field');
			var d;
			if (this.settings.reference && typeof this.settings.reference[customFn] === 'function') {
				d = this.settings.reference[customFn].call(this.settings.reference, field, this.getFormInstance());
			} else {
				if (this.settings.reference) {
					console.log(`InitField function NOT available. Add "${customFn}" in "${(this.settings.reference._FULL_ ? this.settings.reference._FULL_ : this.settings.reference.PANEL_ID)}"`);
				}
				d = field.triggerHandler('init-date-field');
			}
			date = this.utils().date().dateFormat(d, sFormat);
		} else {
			date = this.utils().date().patternToDate(initialValue, sFormat);
		}
		field.val(date);
	},
	resetEditableField: function(field, options) {
		this._super(field, options);
	},
	resetReadOnlyField: function(field, options) {
		if (field.data('show-datepicker')) {
			//TODO: need to analize more this scenario
			field.datepicker('setDate', '');
		} else {
			this._super(field, options);
		}
	},

	/**
	 * Disable Field
	 */
	disableField: function(field, disable) {
		let method = disable ? 'disable' : 'enable';
		field.datepicker(method);
		this.getTrigger(field).button(method);
	},
	wrapForDatepickerAddon: function(field) {
		if (!field.usingChromaFlow()) return;

		const $addon = field.closest('.field-composite').find('[data-variants~="datepicker-addon"]');
		if ($addon.exists() && !$addon.closest('.addon-container').exists()) {
			$addon
				.add($addon.siblings(this.wrappableSelectors))
				.wrapAll('<div class="datepicker-addon-container addon-container field-container"></div>');
		}

		if ($addon.exists()) {
			if ($addon.nextAll(field).exists()) {
				$addon.addClass('addon-before');
				field.addClass('addon-after');
			} else if ($addon.prevAll(field).exists()) {
				field.addClass('addon-before');
				$addon.addClass('addon-after');
			}
		}
	},
	getTrigger: function(field) {
		const $trigger = field.closest('.field-composite').find('.ui-datepicker-trigger');
		return $trigger;
	},
	datePickerButtonHandler: function($trigger, $datepicker, position) {
		$trigger
			.off('.open-datepicker-button')
			.on('click.open-datepicker-button', () => {
				$datepicker
					.removeClass('ui-timepicker')
					.addClass('ui-helper-hidden-invisible')
					.removeClass('closed')
					.attr('data-state', 'open')
					.css({
						top: 'unset',
						left: 'unset',
						right: 'unset',
						bottom: 'unset',
					})
					.position(position);

				$datepicker
					.addClass('closed')
					.attr('data-state', 'closed')
					.removeClass('ui-helper-hidden-invisible');

				$datepicker
					.css({
						opacity: 1
					})
					.stop(true)
					.removeClass('closed')
					.attr('data-state', 'open');
			});
	},
	datePickerFocusHandler: function($trigger, $datepicker, position) {
		$trigger
			.off('.open-datepicker-focus')
			.on('focus.open-datepicker-focus', () => {
				$datepicker
					.removeClass('ui-timepicker')
					.addClass('ui-helper-hidden-invisible')
					.removeClass('closed')
					.attr('data-state', 'open')
					.css({
						top: 'unset',
						left: 'unset',
						right: 'unset',
						bottom: 'unset',
					})
					.position(position);

				$datepicker
					.addClass('closed')
					.attr('data-state', 'closed')
					.removeClass('ui-helper-hidden-invisible');

				$datepicker
					.css({
						opacity: 1
					})
					.stop(true)
					.removeClass('closed')
					.attr('data-state', 'open');
			});
	},
	datePickerCloseHandler: function() {
		let isAlreadyRegistered = $(document).hasEvent('click', 'close-datepicker');
		if (!isAlreadyRegistered) {
			$(document)
				.off('click.close-datepicker')
				.on('click.close-datepicker', (evt) => {
					if (
						$(evt.target).is('.hasDatepicker') ||
						$(evt.target).closest('.hasDatepicker').exists() ||
						$(evt.target).closest('.ui-datepicker').exists() ||
						$(evt.target).closest('.ui-datepicker-prev').exists() ||
						$(evt.target).closest('.ui-datepicker-next').exists()
					) return;

					$('.ui-datepicker')
						.stop(true)
						.attr('data-state', 'closed');

					$('.ui-datepicker')
						.off('.animation')
						.on('animationend.animation', (event) => {
							event.stopPropagation();

							const isClosed = $(event.target).attr('data-state') === 'closed';
							$(event.target)
								.toggleClass('closed', isClosed);

							if (isClosed) {
								$(event.target)
									.css({
										top: 'unset',
										left: 'unset',
										right: 'unset',
										bottom: 'unset',
									});
							}
						});
				});
		}
	}
});